export class Faq extends HTMLElement {
  constructor () {
    super()
    this.button = this.querySelector('.accordion-button')
    this.content = this.querySelector('.accordion-content')
    this.icon = this.querySelector('.accordion-icon')
  }

  connectedCallback () {
    this.button.addEventListener('click', () => {
      this.button.classList.toggle('active')
      this.content.classList.toggle('active')
    })
  }
}

if ('customElements' in window) {
  customElements.define('faq-item', Faq)
}

export class Video extends HTMLElement {
  constructor () {
    super()
    this.button = null
    this.videoWrapper = null
    this.video = null
  }

  connectedCallback () {
    this.button = this.querySelector('.play-button')
    this.videoWrapper = this.querySelector('.video-wrapper')
    this.video = this.querySelector('video')
    if (!this.videoWrapper || !this.video) {
      return
    }
    if (this.button) {
      this.button.addEventListener('click', () => {
        this.videoWrapper.classList.toggle('video_active')
        this.video.play()
         })
       } else {
         // Web Share API not supported in this browser
       }
  }
}

if ('customElements' in window) {
  customElements.define('video-component', Video)
}

export class InputGroup extends HTMLElement {
  constructor () {
    super()
    this.type = null
    this.name = null
    this.wrapper = null
    this.options = []
  }

  connectedCallback () {
    this.type = this.dataset.type
    this.options = this.querySelectorAll('.input-option-main')
    this.name = this.dataset.name
    this.setOptions(this.options)
  }
  setOptions (options) {
    this.options = options
    if (this.type != 'select') {
      this.wrapper = this.querySelector('.input-group__box')
      this.options.forEach(option => {
        let label = option.textContent
        let id = option.getAttribute('id')
        let value = option.getAttribute('value')
        let inputWrapper = document.createElement('span')
        inputWrapper.classList.add('input-option-wrapper')
        inputWrapper.classList.add(`input-option-${this.type}`)
        let input = document.createElement('input')
        let labelElement = document.createElement('label')
        labelElement.setAttribute('for', id)
        labelElement.textContent = label
        labelElement.classList.add('input-option-label')
        input.type = this.type
        input.id = id
        if (this.type === 'checkbox') {
          let svg = `<svg class="icon-check icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M530.8 134.1C545.1 144.5 548.3 164.5 537.9 178.8L281.9 530.8C276.4 538.4 267.9 543.1 258.5 543.9C249.1 544.7 240 541.2 233.4 534.6L105.4 406.6C92.9 394.1 92.9 373.8 105.4 361.3C117.9 348.8 138.2 348.8 150.7 361.3L252.2 462.8L486.2 141.1C496.6 126.8 516.6 123.6 530.9 134z"/></svg>`
          labelElement.innerHTML = labelElement.innerHTML + svg
          input.name = `contact[${this.name}-${value}]`
        } else {
          let svg = `<svg class="icon-radio icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><!--!Font Awesome Free v7.0.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M64 320C64 178.6 178.6 64 320 64C461.4 64 576 178.6 576 320C576 461.4 461.4 576 320 576C178.6 576 64 461.4 64 320z"/></svg>`
          labelElement.innerHTML = labelElement.innerHTML + svg
          input.name = `contact[${this.name}]`
        }
        input.value = value
        input.classList.add('input-option-main')
        inputWrapper.appendChild(labelElement)
        inputWrapper.appendChild(input)
        if (this.wrapper) {
          this.wrapper.appendChild(inputWrapper)
        } else {
          this.appendChild(inputWrapper)
        }
        option.parentNode.remove()
        option.remove()
      })
    }
  }
}

if ('customElements' in window) {
  customElements.define('input-group', InputGroup)
}

export class ShareButton extends HTMLElement {
  #controller = new AbortController()
  #shareUrl = null
  #shareText = null
  #button = null

  connectedCallback () {
    const { signal } = this.#controller
    this.#button = this.querySelector('button') || this
    this.#shareUrl = this.dataset.shareUrl || window.location.href
    this.#shareText = this.dataset.shareText || document.title

    this.#button.addEventListener('click', this.#handleShareClick, { signal })
  }

  disconnectedCallback () {
    this.#controller.abort()
  }

  #handleShareClick = async event => {
    event.preventDefault()
    if (navigator.share) {
       try {
         await navigator.share({
           title: this.#shareText,
           url: this.#shareUrl
         })
       } catch (error) {
         // Error handling omitted
       }
     } else {
       // Web Share API not supported in this browser
     }
  }
}

if (!customElements.get('share-button')) {
  customElements.define('share-button', ShareButton)
}

class CloseButton extends HTMLElement {
  connectedCallback () {
    this.addEventListener('click', this.#handleClick)
  }

  disconnectedCallback () {
    this.removeEventListener('click', this.#handleClick)
  }

  #handleClick = event => {
    event.preventDefault()
    const targetItem = this.getAttribute('aria-controls')
    let target = null
    if (targetItem) {
      target = document.getElementById(targetItem)
    } else {
      // Find closest section ancestor
      target = this.closest('.shopify-section')
    }
    if (target) {
      target.classList.add('close__item')
    }
  }
}

if (!customElements.get('close-button')) {
  customElements.define('close-button', CloseButton)
}

class ProductRecommendations extends HTMLElement {
  constructor () {
    super()
    this._observer = null
    this._handleIntersection = this._handleIntersection.bind(this)
  }

  connectedCallback () {
    this._observer = new IntersectionObserver(this._handleIntersection, {
      rootMargin: '0px 0px 200px 0px'
    })
    this._observer.observe(this)
  }

  disconnectedCallback () {
    if (this._observer) {
      this._observer.disconnect()
    }
  }

  _handleIntersection (entries, observer) {
    if (!entries[0].isIntersecting) return
    observer.unobserve(this)
    const url = this.dataset.url
    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div')
        html.innerHTML = text
        const recommendations = html.querySelector('.product-recommendations')
        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML
         }
       })
       .catch(e => {
         // Error handling omitted
       })
  }
}

if (!customElements.get('product-recommendations')) {
  window.customElements.define(
    'product-recommendations',
    ProductRecommendations
  )
}
